module.exports = __webpack_public_path__ + "img/jameson-4.323a1744.png";